import { render } from "./ClinicalRequisitionsTab.vue?vue&type=template&id=fab53e1a"
import script from "./ClinicalRequisitionsTab.vue?vue&type=script&lang=js"
export * from "./ClinicalRequisitionsTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__